import dayjs from "dayjs";
import { createUniqueId } from "tm-shared/utils";

import { PHOTO_NAME_DATE_FORMAT } from "@/constants/config/dateFormats";
import { photoStorage } from "@/Services/PhotoStorage";

const SEPARATOR = "/";

export const createUploadPhotoMeta = (pointId: string) => {
    const validDate = dayjs().format(PHOTO_NAME_DATE_FORMAT);
    const filename = `${createUniqueId()}.jpg`;

    return {
        filename,
        middlePath: validDate,
        url: [pointId, validDate, filename].join(SEPARATOR),
    };
};

export const parseUploadedUrl = (uploadedUrl: string) => {
    const parts = uploadedUrl.split(SEPARATOR);

    const [pointId, middlePath, filename] = parts;

    if (!pointId || !middlePath || !filename) {
        return null;
    }

    return { pointId, middlePath, filename };
};

export const getUploadPhotoMeta = async ({
    pointId,
    skipUpload,
}: {
    pointId: string;
    skipUpload: boolean;
}) => {
    if (!skipUpload) {
        const photoSlot = await photoStorage.getSlotAndDelete(pointId);
        if (photoSlot) return { ...photoSlot, fromSlot: true as const };
    }

    const meta = createUploadPhotoMeta(pointId);

    return { ...meta, fromSlot: false as const };
};
